const Builder = require('../BuilderBase');

module.exports = class PowerSliderPopup extends Builder {
    constructor(title, properties) {
        super('actionElement_PowerSliderPopup', title, properties);
    }
};
